import { AfterContentInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ITablePrice } from "../../ITablePrice";
import { IStayPriceRow } from "./interfaces/stay-price-row";
import { IStayPriceColsHeaders, IStayPriceColsHeadersTraveller } from "./interfaces/stay-price-cols-headers";
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { ISummarySectorStay } from "../../../sectors/components/shared/interfaces/ISummary";
import { IGetBookingsStayResponse, ITraveller } from "libraries/service/resources/booking/interfaces/IGetBookings";
import {
    IMultiselectConfig,
    IMultiselectOptions
} from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { FormBuilder, FormGroup } from "@angular/forms";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";

import {
    faCreditCard,
    IconDefinition,
    faAngleUp,
    faAngleDown,
    faTags,
    faQuestion, faCircle
} from "@fortawesome/free-solid-svg-icons";
import { IDescriptionLabels } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";
import { FaLayersComponent } from "@fortawesome/angular-fontawesome";
import { FEE_DESCRIPTION } from "libraries/wording/fee-description";

const COLS: string[] = [
    'title', 'total'
];

@Component({
    selector: 'stay-price-tab',
    template: `
        <div class="card-sub-header-content">
            <div class="filter-container">
                <div class="filter-traveller">
                    <multiselect *ngIf="booking.traveller && isFilterReady"
                                 [fieldConfig]="filtersFieldsConfig.traveller"
                                 [options]="filtersOptions.traveller"
                                 [labelCustom]="filtersConfig.traveller.defaultLabel"
                                 [disabled]="isFilterDisabled"></multiselect>
                </div>
            </div>
        </div>
        <div class="container">
            <div *ngIf="showFeeDescription" class="field-description">
                <field-description [description]="feeDescription"
                                   [style.top]="showFeeDescriptionTop"
                                   [style.left]="showFeeDescriptionLeft"
                                   (clickOutside)="toggleDescription()"></field-description>
            </div>
            <div class="total-container">
                <div class="first-col">
                    <div class="fake-cell empty">.</div>
                    <div class="fake-cell">
                        <fa-icon [icon]="iconCreditCard"></fa-icon>
                        <strong>{{wording.total}}</strong></div>
                </div>
                <mat-table [dataSource]="dataSourceTotal">
                    <ng-container matColumnDef="title">
                        <mat-header-cell *matHeaderCellDef
                                         class="text title"></mat-header-cell>
                        <mat-cell *matCellDef="let row" class="title text header-row">
                            <div>{{row.title}}</div>
                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="total">
                        <mat-header-cell *matHeaderCellDef class="value total"> {{colsHeader.total}}</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="value total">
                            <price-real-amount [value]="row.total.amount"
                                               [showZero]="true"
                                               [currency]="row.total.currency"
                                               type="default"></price-real-amount>
                        </mat-cell>
                    </ng-container>

                    <ng-container *ngFor="let travellerId of travellerIds" [matColumnDef]="travellerId">
                        <mat-header-cell *matHeaderCellDef
                                         class="value"> {{colsHeader | travellerName: travellerId}}</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="value">
                            <ng-container *ngIf="row | travellerPrice: travellerId">
                                <price-real-amount [value]="(row | travellerPrice: travellerId).amount"
                                                   [showZero]="true"
                                                   [currency]="(row | travellerPrice: travellerId).currency"
                                                   type="default"></price-real-amount>

                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="rowEnd">
                        <mat-header-cell *matHeaderCellDef class="end"></mat-header-cell>
                        <mat-cell *matCellDef="let row" class="end"></mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="cols"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: cols"></mat-row>

                </mat-table>
            </div>

            <div class="details-container">
                <div class="first-col">
                    <div class="fake-cell">
                        <stay-summary [sector]="sector"
                                      [detailsIsShown]="false"
                                      [booking]="booking"
                                      *ngFor="let sector of sectors; trackBy: trackByFn;"></stay-summary>
                    </div>
                </div>

                <mat-table [dataSource]="dataSourceDetails">
                    <ng-container matColumnDef="title">
                        <mat-cell *matCellDef="let row"
                                  class="text title"
                                  [class.header-row]="row | headerClass"
                                  (click)="collapse(row)">
                            <div>
                                {{row.title}}
                                <ng-container *ngIf="row.type === 'fee'">
                                    <fa-layers (click)="toggleDescription()" #feeDescriptionBtn>
                                        <fa-icon [icon]="iconCircle" class="blue"></fa-icon>
                                        <fa-icon [icon]="iconQuestion" class="white" transform="shrink-5"></fa-icon>
                                    </fa-layers>
                                </ng-container>

                            </div>
                            <div *ngIf="row.collapser">
                                <fa-icon [icon]="collapsed[row.collapser] ? iconAngleDown : iconAngleUp"></fa-icon>
                            </div>

                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="total">
                        <mat-cell *matCellDef="let row" class="value total">
                            <price-real-amount [value]="row.total?.amount"
                                               [currency]="row.total?.currency"
                                               [showZero]="true"
                                               [type]="(row | headerClass) ? 'default' : 'light'"></price-real-amount>
                        </mat-cell>
                    </ng-container>

                    <ng-container *ngFor="let travellerId of travellerIds" [matColumnDef]="travellerId">
                        <mat-cell *matCellDef="let row" class="value">
                            <ng-container *ngIf="row | travellerPrice: travellerId">
                                <price-real-amount [value]="(row | travellerPrice: travellerId).amount"
                                                   [showZero]="true"
                                                   [currency]="(row | travellerPrice: travellerId).currency"
                                                   [type]="(row | headerClass) ? 'default' : 'light'"></price-real-amount>

                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="rowEnd">
                        <mat-cell *matCellDef="let row" class="end"></mat-cell>
                    </ng-container>

                    <mat-row *matRowDef="let row; columns: cols"
                             [hidden]="row.collapseGroup && collapsed[row.collapseGroup]"></mat-row>

                </mat-table>
            </div>
        </div>


    `,
    styleUrls: ['./stay-price-tab.component.scss'],
})

export class StayPriceTabComponent implements OnInit, AfterContentInit {

    @Input()
    public dataSourceTotal: IStayPriceRow[];

    @Input()
    public dataSourceDetails: IStayPriceRow[];

    @Input()
    public colsHeader: IStayPriceColsHeaders;

    @Input()
    public sectors: ISummarySectorStay[];

    @Input()
    public booking: IGetBookingsStayResponse;

    @Input()
    public prices: ITablePrice;

    @ViewChild('feeDescriptionBtn')
    public readonly feeDescriptionBtn: FaLayersComponent;

    public cols: string[] = COLS;

    public travellerIds: string[];

    public travellers: ITraveller[];

    public collapsed: { [key: string]: boolean } = {
        total: false,
        detail: false,
    };

    public readonly wording: ILabels = {
        total: Yii.t('wui-shared-js', 'TOTAL'),
    };

    public isFilterDisabled: boolean;
    public filtersOptions: {
        traveller: IMultiselectOptions[],
    };
    public filterFormGroup: FormGroup;
    public filtersFieldsConfig: {
        traveller: IFieldSpecs,
    };
    public filtersConfig: {
        traveller: IMultiselectConfig,
    };
    public isFilterReady: boolean;

    public readonly iconCreditCard: IconDefinition = faCreditCard;
    public readonly iconAngleDown: IconDefinition = faAngleDown;
    public readonly iconAngleUp: IconDefinition = faAngleUp;
    public readonly iconTags: IconDefinition = faTags;
    public readonly iconQuestion: IconDefinition = faQuestion;
    public readonly iconCircle: IconDefinition = faCircle;

    public showFeeDescription: boolean;
    public showFeeDescriptionTop: string;
    public showFeeDescriptionLeft: string;

    public readonly feeDescription: IDescriptionLabels = FEE_DESCRIPTION;

    constructor(
        private readonly formBuilder: FormBuilder,
    ) {
    }

    public ngOnInit(): void {

        this.travellerIds = (this.colsHeader.traveller || []).map((traveller: IStayPriceColsHeadersTraveller) => traveller.id);

        this.cols = this.computeHeader(this.travellerIds);
    }

    public ngAfterContentInit(): void {
        if (this.booking.traveller) {
            this.initFilters();
            this.isFilterDisabled = this.booking.traveller.length < 2;
        }
    }

    public collapse(row: IStayPriceRow): void {
        if (row.collapser) {
            this.collapsed[row.collapser] = !this.collapsed[row.collapser];
        }
    }

    public trackByFn(index: number): number {
        return index;
    }

    public toggleDescription(): void {
        // @ts-ignore
        const elem: ElementRef = this.feeDescriptionBtn.elementRef;

        this.showFeeDescriptionTop = (Math.round(elem.nativeElement.getBoundingClientRect().top)+15) + "px";
        this.showFeeDescriptionLeft = (Math.round(elem.nativeElement.getBoundingClientRect().left)+15) + "px";
        this.showFeeDescription = !this.showFeeDescription;
    }

    private initFilters(): void {
        this.filtersOptions = getFiltersOptions(this.booking.traveller);
        this.filterFormGroup = initFiltersFormGroup(this.formBuilder, this.filtersOptions);
        this.filtersFieldsConfig = {
            traveller: {
                formGroup: this.filterFormGroup,
                formControlName: "traveller",
            },
        };
        this.filtersConfig = {
            traveller: {
                defaultLabel: Yii.t('wui-shared-js', 'Filtrer sur les voyageurs'),
                displaySelectedLabel: false,
            },
        };
        this.isFilterReady = true;

        this.filterFormGroup.valueChanges
            .subscribe({
                next: (filterValue: { traveller: string[] }): void => {
                    this.cols = this.computeHeader(filterValue.traveller);
                }
            });
    }

    private computeHeader(travellerIds: string[]): string[] {
        return [
            ...COLS,
            ...travellerIds,
            'rowEnd'
        ];
    }
}

function getFiltersOptions(travellers: ITraveller[]): { traveller: IMultiselectOptions[] } {
    const traveller: IMultiselectOptions[] = (travellers || [])
        .map((travellerItem: ITraveller) => ({
            label: `${travellerItem.firstName} ${travellerItem.lastName}`,
            value: travellerItem.xId
        }));
    return {
        traveller,
    };
}

function initFiltersFormGroup(fb: FormBuilder, options: { traveller: IMultiselectOptions[] }): FormGroup {
    return fb.group({
        traveller: fb.control(options.traveller.map((travellerOption: IMultiselectOptions) => travellerOption.value)),
    });
}
